// GraphQL
import gql from 'graphql-tag'
import ApolloClient, {
  createNetworkInterface
} from 'apollo-client'

// Apollo GraphQL Connection
const networkInterface = createNetworkInterface({
  // We use process.env instead of Vue.config.holidays because in this step, Vue
  // is not loaded
  uri: process.env.GRAPHQL_API,
  opts: {
    Accept: 'application/json',
    credentials: 'include'
  }
})

const apolloClient = new ApolloClient({
  networkInterface,
  addTypename: undefined
})

export {
  apolloClient as graphClient,
  gql
}



// WEBPACK FOOTER //
// ./src/graphql.js